













import Vue from 'vue'
import { InstantSwitchElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'InstantSwitchEl',
  props: {
    templateItemData: {
      type: Object as () => InstantSwitchElInterface,
      required: true
    }
  },
  data: () => ({
    selected: false,
    processing: false
  }),
  mounted () {
    this.selected = this.templateItemData.value
  },
  computed: {
    title (): string {
      return this.templateItemData.title.replace('\n', '<br>')
    }
  },
  methods: {
    switchAction () {
      this.processing = true

      this.$axios.post(this.templateItemData.uri, new URLSearchParams({ status: this.selected.toString() }))
        .then(() => {
          this.processing = false
        })
        .catch(() => {
          this.selected = !this.selected
          this.processing = false
        })
    }
  }
})
